import { createContext, type FC, type PropsWithChildren, useMemo } from 'react';

import WebApp from '@twa-dev/sdk';

import { useWs } from '@/shared/hooks/use-ws';
import { type AnalyticsService } from '@/shared/services/analytics/analytics-service';
import { createAnalyticsService } from '@/shared/services/analytics/lib/create-analytics-service';
import { useStartappArgs } from '@/shared/store/tg-store/tg-store';

export const AnalyticsServiceContext = createContext<AnalyticsService | undefined>(
  undefined
);

export const AnalyticsServiceContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const ws = useWs();

  const startAppArgs = useStartappArgs();

  // Waiting for ws connection to send events
  const analyticsService = useMemo(() => {
    return createAnalyticsService(startAppArgs, WebApp?.initDataUnsafe?.start_param, ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnalyticsServiceContext.Provider value={analyticsService}>
      {children}
    </AnalyticsServiceContext.Provider>
  );
};
